// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2wZoD","label":"Radio_label__3h1Is","checkMark":"Radio_checkMark__2TVVx","disabled":"Radio_disabled__r45Pa"};